module.exports = __webpack_public_path__ + "media/dashboard/assets/images/flow-new/menu-icon-action-62c6848b229d1e066bdc90fd39a034f3.svg";